import React from 'react';
import _ from 'lodash';
import UploadingsPopover from './UploadingsPopover';
import Div from '../common/elements/Div';
import StoreListener from '../store/StoreListener';
import {
  COLLECTION_UPLOAD_JOBS,
  ASSET_UPLOAD_JOBS,
  DOWNLOAD_JOBS,
  ASSETLIST_PAGE_NUMBER,
  UPLOAD_FINISHED,
  SHOW_UPLOADS
} from '../store/Constants';
import CollectionUploadJob from '../upload/CollectionUploadJob';
import AssetUploadJob from '../upload/AssetUploadJob';
import PollAndDownloadJob from '../protocol/PollAndDownloadJob';
import Store from '../store/Store';

type Props = {
  COLLECTION_UPLOAD_JOBS: CollectionUploadJob[],
  ASSET_UPLOAD_JOBS: AssetUploadJob[],
  DOWNLOAD_JOBS: PollAndDownloadJob[]
};

type State = {
  showUploadingsPopover: boolean
};

const storeItems = [COLLECTION_UPLOAD_JOBS, ASSET_UPLOAD_JOBS, DOWNLOAD_JOBS];

@StoreListener(storeItems)
export default class UploadingsItem extends React.Component<Props, State> {
  state = {
    showUploadingsPopover: false
  };

  onJobChange = (currentJob) => {
    const assetUploadCount = this.props[ASSET_UPLOAD_JOBS].filter((j) => j.upload && j.upload.status !== 'FINISHED')
      .length;
    if (assetUploadCount == 0) this.onUploadClose();
    this.forceUpdate();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props[ASSET_UPLOAD_JOBS] !== prevProps[ASSET_UPLOAD_JOBS]) {
      this.props[ASSET_UPLOAD_JOBS].forEach((job: FileUploadJob) => {
        job.addListener('change', (job) => this.onJobChange(job));
      });
    }
  }

  getTotalCount = () => {
    const assetUploadJobs: AssetUploadJob[] = this.props[ASSET_UPLOAD_JOBS];
    const assetUploadCount = assetUploadJobs.filter(
      (j) => j.upload && (j.upload.status === 'UPLOADING' || j.upload.status === 'UPLOADED')
    ).length;
    const collectionUploadJobs: CollectionUploadJob[] = this.props[COLLECTION_UPLOAD_JOBS];
    const collectionUploadCount = collectionUploadJobs.length;
    const pollAndDownloadJobs: PollAndDownloadJob[] = this.props[DOWNLOAD_JOBS];
    const runningPollAndDownloadJobs = pollAndDownloadJobs.filter((j) => !j.done && !j.canceled);
    const totalCount = assetUploadCount + collectionUploadCount + runningPollAndDownloadJobs.length;
    return totalCount;
  };
  onUploadClose = () => {
    Store.put(ASSETLIST_PAGE_NUMBER, 0); //Load Assets from page 0
    if (!Store.get(SHOW_UPLOADS)) Store.put(ASSET_UPLOAD_JOBS, []);
    Store.put(UPLOAD_FINISHED, this.props[ASSET_UPLOAD_JOBS]);
    this.state.showUploadingsPopover = false;

    // this.setState({ showUploadingsPopover: false });
  };
  onMouseEnter = () => {
    if (!this.state.showUploadingsPopover && this.getTotalCount()) {
      this.setState({ showUploadingsPopover: true });
    }
  };
  onMouseLeave = () => {
    this.setState({ showUploadingsPopover: false });
  };

  render() {
    const assetUploadJobs: AssetUploadJob[] = this.props[ASSET_UPLOAD_JOBS];
    const collectionUploadJobs: CollectionUploadJob[] = this.props[COLLECTION_UPLOAD_JOBS];

    const pollAndDownloadJobs: PollAndDownloadJob[] = this.props[DOWNLOAD_JOBS];
    const runningPollAndDownloadJobs = pollAndDownloadJobs.filter((j) => !j.done && !j.canceled);

    const totalCount = this.getTotalCount();

    const rect = this._node ? this._node.getBoundingClientRect() : {};
    const position = {
      top: rect.bottom,
      right: window.innerWidth - rect.right
    };
    return (
      <div
        name="UploadingsItem"
        ref={(node) => (this._node = node)}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        style={{ float: 'left' }}>
        {totalCount > 0 ? (
          <div
            className="wrapper-1"
            style={{ height: '70px', width: '80px', display: 'flex', justifyContent: 'space-between' }}>
            <div
              className="progress-wrapper"
              style={{ height: '2px', width: '32px', background: 'var(--separator-color)', margin: 'auto' }}>
              <div className="progress" style={styles.uploading} />
            </div>
            {totalCount && (
              <Div className="count" style={styles.uploadingsCount} title={totalCount}>
                {totalCount}
              </Div>
            )}
          </div>
        ) : null}
        {this.state.showUploadingsPopover ? (
          <UploadingsPopover
            assetUploadJobs={assetUploadJobs}
            collectionUploadJobs={collectionUploadJobs}
            pollAndDownloadJobs={runningPollAndDownloadJobs}
            position={position}
            onClose={() => this.setState({ showUploadingsPopover: false })}
          />
        ) : null}
      </div>
    );
  }
}

const styles = {
  uploading: {
    animation: 'progress 1s linear infinite',
    width: '0',
    height: '2px',
    background: 'var(--primary-style-color)'
  },
  uploadingsCount: {
    fontSize: '9px',
    lineHeight: '17px',
    fontWeight: 'bold',
    color: 'var(--primary-header-bg)',
    background: 'var(--primary-style-color)',
    borderRadius: '50px',
    height: '19px',
    minWidth: '19px',
    maxWidth: '40px',
    padding: '0 6px',
    textAlign: 'center',
    margin: 'auto auto auto 5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
};
